import React, { useEffect, useState } from 'react';
import { useContentfulEntry } from '../hooks/useContentfulEntry';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container'
import PageLoading from './widgets/PageLoading'

import TopImage from './widgets/TopImage'
import ArticleBody from './article/ArticleBody'
import Blog from './article/Blog'
import Footer from './Footer'
import ArticleSidebar from './sidebar/ArticleSidebar'

const layout = {
  sidebar: { body: 9, sidebar: 3 },
  full: { body: 12, sidebar: 0 }
}

const defaults = {
  'general-article': {
    showSidebar: false,
    showRelatedArticles: true,
    showNavigation: true,
    showTags: true,
    showHeadline: true,
  },
  'blog-home-page': {
    showSidebar: true,
    showRelatedArticles: true,
    showNavigation: true,
    showTags: true,
    showHeadline: true,
  },
  'blog-list': {
    showSidebar: true,
    showRelatedArticles: true,
    showNavigation: true,
    showTags: true,
    showHeadline: true,
  },
  'blog-post': {
    showSidebar: true,
    showRelatedArticles: true,
    showNavigation: true,
    showTags: true,
    showHeadline: true,
  },
  'events-home-page': {
    showSidebar: true,
    showRelatedArticles: true,
    showNavigation: true,
    showTags: true,
    showHeadline: true,
  },
  'event-list': {
    showSidebar: true,
    showRelatedArticles: true,
    showNavigation: true,
    showTags: true,
    showHeadline: true,
  },
  'event': {
    showSidebar: true,
    showRelatedArticles: true,
    showNavigation: true,
    showTags: true,
    showHeadline: true,
  },
  '404': {
    showSidebar: false,
    showRelatedArticles: false,
    showNavigation: false,
    showTags: false,
    showHeadline: true,
  },
}

function Article(props) {
  const { routeType, articleType, id } = props;
  const { entry: articleResponse, loading, error } = useContentfulEntry(id);

  const [mainEntry, setMainEntry] = useState(null);

  useEffect(() => {
    if (articleResponse && articleResponse.items) {
      setMainEntry(articleResponse.items[0]);
    }
  }, [articleResponse]);

  if (loading) {
    return <PageLoading />;
  }
  if (error) {
    return <div>Error loading article.</div>;
  }
  if (!mainEntry) {
    return null;
  }

  let showSidebar = mainEntry && mainEntry.fields.showSidebar ? defaults[articleType].showSidebar : false;
  const widths = showSidebar ? layout.sidebar : layout.full;

  if (mainEntry && defaults[articleType]) {
    mainEntry.fields.showHeadline = mainEntry.fields.showHeadline ?? defaults[articleType].showHeadline;
    mainEntry.fields.showRelatedArticles = mainEntry.fields.showRelatedArticles ?? defaults[articleType].showRelatedArticles;
    mainEntry.fields.showNavigation = mainEntry.fields.showNavigation ?? defaults[articleType].showNavigation;
    mainEntry.fields.showTags = mainEntry.fields.showTags ?? defaults[articleType].showTags;
  }

  return (
    <Container fluid id='article'>
      <Row style={{ marginLeft: -20, marginRight: -20, marginTop: -20 }}>
        <TopImage article={mainEntry}  {...props} />
      </Row>
      <Row>
        <Col lg={widths.body}>
          <Blog {...props} articleType={articleType} />
          <ArticleBody
            href={props.href}
            article={mainEntry}
            sections={mainEntry.fields.sections}
            default={defaults[articleType]}
            {...props}
          />
        </Col>
        {showSidebar &&
          <Col lg={widths.sidebar}>
            <ArticleSidebar
              article={mainEntry}
              articleType={articleType}
              routeType={routeType}
              {...props}
            />
          </Col>
        }
      </Row>
      <Row style={{ marginLeft: -20, marginRight: -20 }}>
        <Footer />
      </Row>
    </Container>
  );
}

export default Article;
